import { useEffect } from "react";

interface Props {
  to: string;
}

export const NavigateOut = ({ to }: Props) => {
  useEffect(() => {
    window.location.href = to;
  }, []);
  return null;
};
